import React from "react";
import { Avatar, colors, createStyles, makeStyles, Theme, withStyles } from "@material-ui/core";
import Badge from '@material-ui/core/Badge';
import { Link } from "react-router-dom";
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import { City } from "../../models/City";
import { Paths } from "../../helpers/constants";


interface CityMarkerProps {
    city: City
}

const SmallBadge = withStyles((theme: Theme) =>
    createStyles({
        badge: {
            border: `2px solid ${theme.palette.background.paper}`,
            borderRadius: '50%',
            width: theme.spacing(2.5),
            height: theme.spacing(2.5),
        },
    }),
)(Badge);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        small: {
            width: theme.spacing(3.5),
            height: theme.spacing(3.5),
            backgroundColor: colors.indigo[200]
        },
        verySmall:{
            width: theme.spacing(2.75),
            height: theme.spacing(2.75), 
            backgroundColor: colors.indigo[300]
        }
    }),
);

export const CityMarker = ({ city }: CityMarkerProps) => {
    const classes = useStyles();
    const MarkerWithBadge = () => {
        return (<>
            <Badge
                overlap="circle"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                badgeContent={<SmallBadge color="secondary" overlap="circle" badgeContent={city.locationsAmount || 0} />
                }
            >
                <Avatar className={classes.small} alt={`Ikonka lokalizacji ${city.name}`}>{city.name.charAt(0)}</Avatar>
            </Badge></>)
    }

    const Marker = () => {
        return(<Avatar className={classes.verySmall} alt={`Ikonka lokalizacji ${city.name}`}><RoomOutlinedIcon /></Avatar>)
    }
    const hasMoreThanOneLocation = (city.locationsAmount || 0) > 1;
    return (
        <Link to={Paths.map.viewCity(city.link)} style={{ display: 'flex', textDecoration: "none", color: "inherit" }}>
            {hasMoreThanOneLocation ? MarkerWithBadge() : Marker()}
        </Link>
    );
}